module.exports = {"id":"194717","name":"Romain Grange","rating":"71","photo":"./data/images/photos/1/194717.png","club":{"name":"Sp. Charleroi","logo":"./data/images/clubs/Sp.Charleroi.png"},"positions":["MD","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RomainGrange0.json
// module id = 3687
// module chunks = 0